<script setup>
import Vue, {reactive, ref, inject} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import needsService from "@/services/needs.service";

const need = inject('need');
const showModal = ref(false);
const loading = ref(false);

const form = reactive({
    comment: ''
});

function open() {
    form.comment = '';
    showModal.value = true;
}

async function send() {
    loading.value = true;
    const {data} = await needsService.sendUpgradeRequest(need.value.id, form);

    if (data) {
        showModal.value = false;

        Vue.notify({
            group: 'app',
            type: 'success',
            duration: 3000,
            text: "Upgrade Request Sent"
        })
    }

    loading.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Request Upgrade">
        <p>Supercharge your innovation lifecycle by tapping into SwitchPitch’s full feature set:</p>

        <ul>
            <li>Search over 480,000 startups</li>
            <li>50+ VC, accelerator and incubator partners</li>
            <li>Custom diligence assessment tools</li>
            <li>Unlimited projects</li>
            <li>Dashboards & AI reporting</li>
        </ul>

        <form class="form">
            <div class="form__item">
                <b-form-textarea
                    v-model="form.comment"
                    class="form-control--mid mb-3"
                    placeholder="Add a note (optional)"
                />
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                caption="Request Upgrade"
                :loading="loading"
                @click="send"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
